import {
  SET_RENEWAL_DASHBOARD_V2_FILTERS,
  RENEWAL_DASHBOARD_V2_LIST,
  SNACKBAR_V2_NOTIFICATION,
  RENEWAL_DASHBOARD_DRILLDOWN_DATA,
  RENEWAL_DASHBOARD_DETAILS_DATA,
} from "../actions/renewalDashboardV2.action";

const defaultState = {};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_RENEWAL_DASHBOARD_V2_FILTERS:
      return {
        ...state,
        renewalDashboardV2Filters: action.payload,
      };
    case RENEWAL_DASHBOARD_V2_LIST:
      return {
        ...state,
        renewalDashboardV2List: action.payload,
      };
    case SNACKBAR_V2_NOTIFICATION:
      return {
        ...state,
        snackbar: {
          state: true,
          type: action.snackBarType || "success",
          duration: action.duration || null,
          message: action.msg || "Success!!",
        },
      };
    case RENEWAL_DASHBOARD_DRILLDOWN_DATA:
      return {
        ...state,
        renewalDashboardDrilldownData: action.payload,
      };
    case RENEWAL_DASHBOARD_DETAILS_DATA:
      return {
        ...state,
        renewalDashboardDetailsData: action.payload,
      };
  }
};

export default reducer;
